import img1 from "../Images/yt_1.png";
import img2 from "../Images/yt_2.png";
import img3 from "../Images/yt_3.jpg";
import img4 from "../Images/yt_4.jpg";

export const images = [
    { img: img1, link: "https://youtu.be/UuApQ8V5MRo" },
    { img: img2, link: "https://youtu.be/Fg1h0LRTZe0" },
    { img: img3, link: "https://youtu.be/BgLyxNohwX4" },
    { img: img4, link: "https://youtu.be/I5caTm48EpY" },
    { img: img1, link: "https://youtu.be/UuApQ8V5MRo" },
    { img: img2, link: "https://youtu.be/Fg1h0LRTZe0" },
    { img: img3, link: "https://youtu.be/BgLyxNohwX4" },
    { img: img4, link: "https://youtu.be/I5caTm48EpY" },
];